/* ============================================================
   VOF Product Page — Chevron, Add-to-Cart, Disabled Sync
   ============================================================ */
(function () {
  "use strict";

  /* ── "+" button → hidden Add-to-Cart ───────────────────── */
  var addBtn = document.querySelector("[data-vof-add-to-cart]");
  var submitBtn = document.querySelector("[data-add-to-cart]");

  if (addBtn && submitBtn) {
    addBtn.addEventListener("click", function () {
      if (addBtn.disabled) return;
      submitBtn.click();
    });

    /* Sync disabled state via MutationObserver */
    var syncDisabled = function () {
      var isDisabled = submitBtn.getAttribute("aria-disabled") === "true";
      addBtn.disabled = isDisabled;
      addBtn.setAttribute("aria-disabled", isDisabled ? "true" : "false");
    };

    syncDisabled(); /* initial state */

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (
          m.attributeName === "aria-disabled" ||
          m.attributeName === "disabled"
        ) {
          syncDisabled();
        }
      });
    });
    observer.observe(submitBtn, { attributes: true });
  }
})();
